<template>
 <Head>
    <title> {{capitalizeTxt(filter)}} Report Render | {{$page.props.appName}}</title>
    <meta name="description" :content="'Pending Expired ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-full p-3 overflow-x-auto overflow-y-auto">
        <h1 class="text-2xl font-semibold ml-1 capitalize">{{filter}} Report</h1>
         <p class="ml-1">Please see below your report for {{filter}} tickets.</p>
          <table class="ml-1">
            <thead>
              <th>Staff Member</th>
              <th>Skill</th>
              <th>Expiry Date</th>
            </thead>
            <tbody>
              <Link as="tr" v-for="(skill,key) in skills" :key="key" :href="'/admin/skills/' + skill.staff.id" class="bg-white cursor-pointer hover:bg-gray-200">
                <td class="border border-black font-medium px-3 py-2 text-black">{{skill.staff.first_name}} {{skill.staff.surname}}</td>
                <td class="border border-black font-medium px-3 py-2 text-black">{{skill.skill.skill_name}}</td>
                <td class="border border-black font-medium px-3 py-2 text-black">{{toReadableDate(skill.expiry_date)}}</td>
              </Link>
            </tbody>
          </table>

    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import moment from 'moment';
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head },
  props: {
    skills: Object,
    filter : String,
    },
  data() {
    return {
      form: this.$inertia.form({
        filter: 'pending'
      }),
    };
  },
  methods: {
    capitalizeTxt(txt) {
      return txt.charAt(0).toUpperCase() + txt.slice(1); 
    },
    store() {
      this.form.post("/admin/reports/pendingexpiredtickets");

    },
    toReadableDate(date) {
      return moment(date).format("DD/MM/Y")
    }
   
  },
};
</script>
     